import { Factory } from 'lucide-react'
import { useNavigate, useParams } from 'react-router-dom'
import { EmptyState } from '@/components/shared/EmptyState'
import { ROUTES } from '@/constants/routes'
import { buildPath } from '@/utils/url'
import { AssetDetailTabs } from './components/AssetDetailTabs'
import { AssetTree } from './components/AssetTree'

/**
 * Assets module: master-detail. The left tree lists the asset hierarchy; the
 * right panel shows the selected asset's detail (overview / gateways / tags).
 * Selection lives in the URL (/assets/:id) so views are shareable.
 */
export function AssetsPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  return (
    <div className="flex h-full">
      <AssetTree
        selectedId={id}
        onSelect={(assetId) => navigate(buildPath(ROUTES.ASSET_DETAIL, { id: assetId }))}
      />
      <div className="flex-1 overflow-auto">
        {id ? (
          <AssetDetailTabs assetId={id} />
        ) : (
          <EmptyState
            icon={<Factory size={40} />}
            title="Select an asset"
            message="Choose an asset from the tree to view its gateways, tags, and details."
          />
        )}
      </div>
    </div>
  )
}
